// src/pages/Reports.js
import React from "react";
import { FileText, Download, BarChartHorizontal } from "lucide-react"; // Icons

export default function Reports() {
    return (
        <div className="min-h-screen bg-darkBg text-white p-6">
            <header className="mb-10 text-center">
                <h1 className="text-4xl font-extrabold text-neonBlue custom-glow-text">
                    📈 Reports & Analytics
                </h1>
                <p className="text-gray-400 mt-2">Analyze historical sensor data.</p>
            </header>

            <div className="glass-card glow-border p-8 max-w-2xl mx-auto rounded-xl text-center">
                <BarChartHorizontal className="text-neonPink mx-auto mb-4" size={48} />
                <h2 className="text-2xl font-semibold mb-4">Coming Soon!</h2>
                <p className="text-gray-300 mb-2">
                    This section will allow you to generate reports and visualize trends over longer periods.
                </p>
                <ul className="list-disc list-inside text-gray-400 text-left inline-block mb-6">
                    <li>View daily, weekly, or monthly averages.</li>
                    <li>Download sensor data as CSV <Download size={16} className="inline ml-1" />.</li>
                    <li>Compare data across multiple devices.</li>
                    <li>Identify anomalies or specific events.</li>
                </ul>
                <p className="text-sm text-gray-500">Stay tuned for updates!</p>
            </div>
        </div>
    );
}